import { render, staticRenderFns } from "./NewsfeedCreate.vue?vue&type=template&id=267e4124&"
import script from "./NewsfeedCreate.vue?vue&type=script&lang=js&"
export * from "./NewsfeedCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports